// client/src/hooks/usePmPortalAuth.js
// The third auth hook, alongside useAuth.js (staff) and useClientPortalAuth.js. Its own
// localStorage key, its own login endpoint, no shared state with either of the others —
// an owner and a staff member may well be the same person at the same desk, and the two
// sessions must not overwrite each other.
import React, { useCallback } from 'react';

const TOKEN_KEY = 'pmPortalToken';
const ROLE_KEY = 'pmPortalRole';

export const usePmPortalAuth = () => {
    const [token, setToken] = React.useState(localStorage.getItem(TOKEN_KEY));
    const [role, setRole] = React.useState(localStorage.getItem(ROLE_KEY));
    const [error, setError] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    const logout = useCallback(() => {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(ROLE_KEY);
        setToken(null);
        setRole(null);
        window.location.href = '/pm-portal/login';
    }, []);

    const login = async (login_email, password) => {
        setLoading(true);
        setError('');
        try {
            const response = await fetch('/api/pm-portal/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ login_email, password }),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Login failed');
            localStorage.setItem(TOKEN_KEY, data.token);
            localStorage.setItem(ROLE_KEY, data.role);
            setToken(data.token);
            setRole(data.role);
            return { mustChangePassword: !!data.mustChangePassword, role: data.role };
        } catch (err) {
            setError(err.message);
            return null;
        } finally {
            setLoading(false);
        }
    };

    return { token, role, login, logout, error, loading };
};
